<!-- TODO use animation-view example to create custom component that can accepto multiple components to animate. -->


<template>
  <div
    :class="{active: userSubmenuOpened}"
    class="wrapper flex">
    <div
      class="user-info greedy"
      title="Toggle menu"
      @click="toggleMenuDropdown">
      <span
        :style="avatar ? `background-image: url(${avatar})` : ''"
        class="user-avatar round-wrap no-shrink">
        {{ avatar ? '' : userName | initials }}
        <span
          :class="{green: available, red: !available}"
          class="indicator"/>
      </span>
      <span class="name ellipsis">{{ userName }}</span>
      <span class="arrow" />
    </div>
    <div
      v-if="activateOrganisation"
      class="user-info greedy top-layer"
      :class="{ active: userSubmenuOpened }"
      title="Toggle menu"
      @click="toggleMenuDropdown">
      <span
        :style="avatar ? `background-image: url(${avatar})` : ''"
        class="user-avatar round-wrap no-shrink">
        {{ avatar ? '' : userName | initials }}
      </span>
      <span class="name ellipsis">{{ userName }}</span>
      <span class="arrow" />
    </div>
    <!-- v-if="currentOrganisation.businesses.length" -->
    <b-button
      v-if="!basic"
      id="new-message"
      class="m-0 p-0 rounded"
      @click="startNewConversation" >
      <SBIcon
        :icon="SBIconList.NEW_MESSAGE"
        :color="SBColors.white"
        :background-color="SBColors.bluePrimary"
        :border-radius="50"
        :hover-size="30"
        :size="14" />
    </b-button>
    <b-popover
      v-if="!basic"
      ref="branchFilterPopover"
      target="new-message"
      triggers="manual"
      placement="bottom"
      custom-class="interactive-popover"
      @show="startBranchSelect"
      @hide="endBranchSelect" >
      <SelectBranch
        v-click-outside="closePopover"
        title="Send from"
        only-available
        @branch-selected="startNewConversationForBranch" />
    </b-popover>
    <b-popover
      v-if="!filterBranchPopoverVisible"
      ref="newMessagePopover"
      target="new-message"
      triggers="hover"
      placement="bottom"
      custom-class="basic-popover" >
      Send new message
    </b-popover>
    <div
      v-if="userSubmenuOpened"
      v-click-outside="closeMenuDropdown"
      class="floating-submenu">
      <div class="animation-view">
        <div
          class="main-view"
          :class="{'go-out': showOrgSelectView, 'min-height': !showMain}" >
          <section class="user-section">
            <span
              :style="avatar ? `background-image: url(${avatar})` : ''"
              class="avatar round-wrap no-shrink">
              {{ avatar ? '' : userName | initials }}
            </span>
            <div class="details">
              <div class="name ellipsis">{{ userName }}</div>
              <div class="email ellipsis">{{ email }}</div>
            </div>
          </section>
          <section
            v-if="!basic && !activateOrganisation"
            class="availability-section flex center-all">
            <span class="status">Away mode</span>
            <SBIcon
              id="UserAvailabilityDescription"
              :icon="SBIconList.INFO"
              :color="SBColors.greyPrimary"
              :background-color="SBColors.white"
              :size="12"
              :hover-size="22"
              :border-radius="20" />
            <span class="greedy" />
            <SwitchCheckbox
              id="UserAvailabilitySwitch"
              :value="!available"
              class="dropdown-check"
              size="mini no-label-margin"
              outline-color="#ff5b61"
              switch-color="#ffffff"
              off-outline-color="#bac8ce"
              off-switch-color="#ffffff"
              @input="toggleAvailability"/>

            <b-popover
              target="UserAvailabilityDescription"
              triggers="hover"
              placement="top"
              :delay="{ show: 200, hide: 0 } " >
              Turn on away mode to inform your team members you are not available at the moment.
            </b-popover>
          </section>
          <section
            class="links-section">
            <div
              v-if="!basic"
              class="item"
              @click="orgSelectToggle">
              <span
                class="org-logo"
                :style="`background-image: url(${currentOrganisation.logo});`" />
              <p class="title greedy ellipsis">{{ currentOrganisation.name }}</p>
              <SBIcon
                :icon="SBIconList.DOWN_ARROW"
                class="rotate-270"
                :color="SBColors.greyPrimary"
                :size="12" />
            </div>
            <router-link
              v-if="!basic"
              class="item"
              :to="{ name: 'ProfileInfo' }"
              @click.native="closeMenuDropdown">
              <span class="custom-icon user-account" />
              <span class="title">Account</span>
            </router-link>
            <a
              class="item"
              @click="logout">
              <span class="custom-icon user-logout" />
              <span class="title">Log Out</span>
            </a>
          </section>
        </div>
        <div
          class="org-select-view relative"
          :class="{'go-in': showOrgSelectView, 'min-height': !showOrgSelect}" >

          <SBIcon
            :icon="SBIconList.DOWN_ARROW"
            class="rotate-90 back-icon show-hand"
            :color="SBColors.greyPrimary"
            :hover-icon-color="SBColors.blackPrimary"
            :size="12"
            hover-color="#f7f9fb"
            :hover-size="24"
            @click="orgSelectToggle" />

          <span class="new-organisation flex center-all">
            <SBIcon
              id="new-org-icon"
              :icon="SBIconList.PLUS_THIN"
              :color="SBColors.bluePrimary"
              :size="12"
              hover-color="#f7f9fb"
              :hover-size="24"
              @click="() => {}" />
            <b-popover
              target="new-org-icon"
              custom-class="basic-popover"
              triggers="hover"
              placement="top"
              :delay="{ show: 200, hide: 0 } " >
              Add new organisation.
            </b-popover>
          </span>

          <SearchableList
            title="Select organisation"
            :item-list="organisationList"
            :filter-fn="(searchTerm) => { return item => item.name && item.name.toLowerCase().indexOf(searchTerm) !== -1;}"
            :no-focus="true"
            @item-selected="selectOrganisation">
            <template #default="slotProps">
              <router-link
                :to="{ name: 'OrganisationWithId', params: { organisationId: slotProps.item.id, clearConversationCache: true }}"
                tag="div"
                class="greedy sb2-dropdown-item flex flex-align-center w-100">
                <span
                  v-if="slotProps.item.logo !== ''"
                  class="org-logo in-list"
                  :style="`background-image: url(${slotProps.item.logo});`" />
                <SBIcon
                  v-else
                  class="org-logo"
                  :icon="SBIconList.BUSINESS"
                  :color="SBColors.white"
                  background-color="#9EAEB5"
                  :border-radius="100"
                  :size="10"
                  :hover-size="20" />
                <span
                  class="title-wrap greedy ellipsis"
                  :inner-html.prop="slotProps.item.name | boldMatch(slotProps.searchTerm)" />
                <SBIcon
                  v-if="currentOrganisation.id === slotProps.item.id"
                  :icon="SBIconList.DONE_TICK"
                  :color="SBColors.bluePrimary"
                  :size="9" />
              </router-link>
            </template>
          </SearchableList>
        </div>
      </div>
    </div>

    <NewConversationModal ref="newConversationModal" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ClickOutside from 'v-click-outside';
import SwitchCheckbox from '../../common/SwitchCheckbox';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SearchableList from '../../common/SearchableList';
import NewConversationModal from '@/components/business/chat/modals/NewConversation.modal';
import SelectBranch from '@/components/business/branch/SelectBranch';

const { mapFields } = createHelpers({
  getterType: 'user/getField',
  mutationType: 'user/updateField',
});

export default {
  name: 'UserOptions',
  directives: {
    ClickOutside: ClickOutside.directive,
  },
  components: {
    SwitchCheckbox,
    SearchableList,
    NewConversationModal,
    SelectBranch,
    SBIcon,
  },
  props: {
    basic: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      userSubmenuOpened: false,
      showOrgSelectView: false,
      showOrgSelect: false,
      showMain: true,
      filterBranchPopoverVisible: false,
      newConversationTargetBranch: null,
      newConversationActive: false,
      SBColors,
      SBIconList,
    };
  },
  computed: {
    ...mapGetters({
      userName: 'user/name',
      userLoaded: 'user/userLoaded',
      available: 'organisation/myAvailability',
      currentOrganisation: 'organisation/currentOrganisation',
      organisationList: 'organisation/organisationList',
    }),
    ...mapFields([
      'avatar',
      // 'available',
      'email',
    ]),
    // maybe pass organisationId as prop
    organisationId() { return this.$route.params.organisationId; },
    activateOrganisation() {
      return this.currentOrganisation && (this.currentOrganisation.should_activate_account || this.currentOrganisation.should_reactivate_account);
    },
  },
  mounted() {
    this.$eventBus.$on('disable-new-message', () => { this.newConversationActive = true; });
    this.$eventBus.$on('enable-new-message', () => { this.newConversationActive = false; });

    this.$eventBus.$on('initiate-new-conversation', () => { this.startNewConversation(); });

    if (!this.userLoaded) {
      // this.fetchUser();
    }
  },
  methods: {
    ...mapActions({
      fetchUser: 'user/fetchUser',
      logout: 'user/logout',
      setAvailability: 'organisation/setMyAvailability',
      setOrganisationSplash: 'organisation/setOrganisationSplash',
      getOrgInfo: 'organisation/getOrgInfo',
    }),
    ...mapMutations({
      CURRENT_ORGANISATION_SET_DATA: 'organisation/CURRENT_ORGANISATION_SET_DATA',
    }),
    toggleMenuDropdown() {
      this.userSubmenuOpened = !this.userSubmenuOpened;
      this.$nextTick(() => {
        if (!this.userSubmenuOpened) {
          this.showOrgSelectView = false;
          this.showOrgSelect = false;
          this.showMain = true;
        }
      });
    },
    closeMenuDropdown() {
      this.userSubmenuOpened = false;
      this.showOrgSelectView = false;
      this.showOrgSelect = false;
      this.showMain = true;
    },
    getFirstMerchantId(organisation) {
      return this.$lodash.isEmpty(organisation.businesses) ? null : organisation.businesses[0].id;
    },
    toggleAvailability() {
      this.setAvailability({ organisationId: this.organisationId, isAvailable: !this.available });
    },
    orgSelectToggle() {
      this.showOrgSelectView = !this.showOrgSelectView;
      if (this.showOrgSelectView) {
        this.showOrgSelect = true;
        setTimeout(() => {
          this.showMain = false;
        }, 80);
      } else {
        this.showMain = true;
        setTimeout(() => {
          this.showOrgSelect = false;
        }, 80);
      }
    },
    selectOrganisation(selectedOrganisation) {
      if (selectedOrganisation.id === this.currentOrganisation.id) {
        this.orgSelectToggle();
      } else {
        this.setOrganisationSplash({ message: 'Getting everything ready...' });
        window.location.reload(); // This reloads the page when the orgnisation is changed because pushing to router is coliding with something and it needs to be fixed on rewrite.
        this.getOrgInfo(selectedOrganisation.id);
        this.CURRENT_ORGANISATION_SET_DATA(selectedOrganisation);
        this.$nextTick(() => {
          this.$router.push({
            name: 'OrganisationWithId',
            params: {
              organisationId: selectedOrganisation.id,
            },
          }).catch(() => {});
          this.toggleMenuDropdown();
        });
      }
    },
    startBranchSelect() {
      this.filterBranchPopoverVisible = true;
      this.$refs.newMessagePopover.$emit('disable');
    },
    closePopover() {
      this.$refs.branchFilterPopover.$emit('close');
    },
    endBranchSelect() {
      this.filterBranchPopoverVisible = false;
    },
    startNewConversation() {
      if (this.$refs.newMessagePopover) {
        this.$refs.newMessagePopover.$emit('close');
      }
      if (this.filterBranchPopoverVisible) {
        this.$refs.branchFilterPopover.$emit('close');
        return;
      }
      if (this.currentOrganisation.businesses.length === 1) {
        this.startNewConversationForBranch(this.currentOrganisation.businesses[0]);
      } else if (!['OrganisationConversation', 'OrganisationWithId'].includes(this.$route.name) && this.$route.params.businessId) {
        this.startNewConversationForBranch(this.currentOrganisation.businesses.find(business => business.id === this.$route.params.businessId));
      } else if (this.currentOrganisation.businesses.length > 1) {
        this.$refs.branchFilterPopover.$emit('open');
      }
    },
    startNewConversationForBranch(branch) {
      this.$refs.branchFilterPopover.$emit('close');
      this.newConversationTargetBranch = branch;
      this.$router
        .push({
          name: 'OrganisationBusiness',
          params: {
            organisationId: this.currentOrganisation.id,
            businessId: this.newConversationTargetBranch.id,
          },
        })
        .catch(() => {})
        .finally(() => {
          this.$eventBus.$emit('show-contact-search-view', this.newConversationTargetBranch);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.top-layer {
  z-index: 9999999999;
  background: #e6e7e8;
  position: absolute;
  top: 11px;
  left: 12px;
  padding: 6px 11px 7px 8px;
  border-radius: 5px;

  &:hover, &.active {
    background: $white;
  }

  .user-avatar {
    margin-left: 0 !important;
  }
}

.wrapper {
  position: relative;
  font-size: 14px;
  padding: 15px 0;
}
.user-info {
  display: flex;
  justify-content: left;
  align-items: center;
  cursor: pointer;
  max-width: 100%;
  min-width: 0;
}

.round-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  background: $greyPrimary no-repeat 50% 50%;
  background-size: cover;
  color: $white;
  border-radius: 50%;
  vertical-align: middle;
  text-transform: uppercase;
  text-align: center;
}

.user-avatar {
  position: relative;
  height: 26px;
  width: 26px;
  margin: 0 15px;
  //line-height: 24px;
  font-size: 12px;
  font-weight: 600;
  vertical-align: center;

  .indicator {
    display: inline-block;
    position: absolute;
    bottom: -2px;
    right: -2px;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    border: white 2px solid;

    &.red {
      background-color: $redPrimary;
    }
    &.green {
      background-color: $greenPrimary;
    }
  }
}
.name {
  font-size: 14px;
  font-weight: bold;
  color: #141c20;
}

.arrow {
  margin-left: 6px;
  height: 16px;
  min-width: 12px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url('~@/assets/img/SB-Icons/down-arrow-light.svg');
}

.wrapper.active .arrow, .user-info:hover .arrow {
  background-image: url('~@/assets/img/SB-Icons/down-arrow-dark.svg');
}

.floating-submenu {
  overflow: hidden;
  position: absolute;
  width: 299px;
  z-index: 9999999999;
  margin: 37px 12px 0 12px;
  border-radius: 5px;
  box-shadow: 0 2px 5px 0 rgba(13, 15, 22, 0.23);
  background-color: $white;

  section {
    border-bottom: solid 1px $greyBorderSecondary;

    &:last-of-type {
      border-bottom: none;
    }
  }

  .user-section {
    padding: 12px;
    display: flex;
    justify-content: left;
    align-items: center;

    .avatar {
      height: 30px;
      width: 30px;
      border-radius: 15px;
      position: relative;
      margin: 0;
      font-size: 16px;
      font-weight: 600;
    }
    .details {
      margin-left: 8px;
      max-width: calc(100% - 38px);

      .name {
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: left;
        color: $blackPrimary;
      }
      .email {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.4;
        letter-spacing: normal;
        text-align: left;
        color: $blackUltralight;
      }
    }
  }
  .availability-section {
    padding: 12px;

    .status {
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
    }

    .description {
      padding-right: 24px;
      margin-top: 5px;
      font-size: 12px;
      line-height: 1.4;
      text-align: left;
      color: $greyPrimary;
    }
  }

  .links-section {
    display: flex;
    flex-direction: column;

    // reset router link styling
    a, a:hover {
      text-decoration: none;
      color: inherit;
    }

    .item {
      padding: 14px 12px;
      cursor: pointer;
      display: flex;
      align-items: center;

      &:last-of-type {
        border-radius: 0 0 5px 5px;
      }

      .custom-icon {
        height: 16px;
        width: 16px;
        display: inline-block;
        background-repeat: no-repeat;
        background-position: center;

        &.user-account {
          background-image: url('~@/assets/img/SB-Icons/profile-square.svg');
        }
        &.user-business {
          background-image: url('~@/assets/img/SB-Icons/user-business-light.svg');
        }
        &.user-logout {
          background-image: url('~@/assets/img/SB-Icons/logout.svg');
        }
      }
      .title {
        margin-left: 12px;
        margin-right: 12px;
      }


      &:hover {
        background-color: $hover;

        .custom-icon {
          // &.user-account {
          //   background-image: url('~@/assets/img/SB-Icons/user-account-dark.svg');
          // }
          // &.user-business {
          //   background-image: url('~@/assets/img/SB-Icons/user-business-dark.svg');
          // }
          // &.user-logout {
          //   background-image: url('~@/assets/img/SB-Icons/user-logout-dark.svg');
          // }
        }
      }
    }
  }

}

.rotate-90 {
  transform: rotate(90deg);
}

.rotate-270 {
  transform: rotate(270deg);
}

.animation-view {
  width: 200% !important;
  display: flex !important;

  .main-view {
    width: 100% !important;
    max-width: 299px !important;
    transition: all .08s ease-in;

    &.go-out {
      transform: translateX(-100%);
    }
  }

  .org-select-view {
    width: 100% !important;
    max-width: 299px !important;
    transition: all .08s ease-in;

    .header {
      border-bottom: solid 1px $greyBorderModal;

      h3 {
        font-size: 14px;
        font-weight: 500;
        padding: 15px 27px;
        text-align: center;
        color: #2a383f;
      }
    }

    &.go-in {
      transform: translateX(-100%);
    }
  }

  .min-height {
    max-height: 1px;
    overflow: hidden;
  }
}

.org-logo {
  width: 18px;
  height: 18px;
  background-position: center;
  background-size: cover;
  border-radius: 100px;

  &.in-list {
    width: 20px;
    height: 20px;
  }
}

.title-wrap {
  margin-right: 15px;
}

.select-item-box {
  width: 100%;
}

.back-icon {
  position: absolute;
  top: 11px;
  left: 10px;
  z-index: 100;
}

.new-organisation {
  position: absolute;
  right: 10px;
  top: 11px;
  font-size: 14px;
  font-weight: 500;
  color: $bluePrimary;
  z-index: 100;
  cursor: pointer;

  .sb-icon {
    margin-right: 0px;
  }

  &:hover {
    color: $blackPrimary;

    ::v-deep .sb-icon span.icon.mask {
      background-color: $blackPrimary !important;
    }
  }
}

#new-message {
  margin-right: 15px !important;
  margin-left: 10px !important;
  box-shadow: none !important;
  border: none !important;

  &:hover {
    box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.3) !important;
  }
}

::v-deep .search-results-list {
  li {
    padding: 8px 15px;

    &:hover {
      background-color: $hover;
      cursor: pointer;
    }

    .org-logo {
      margin-right: 8px;
    }
  }
}
</style>
